import { useEffect } from 'react';
import { X } from 'lucide-react';

export interface ItemImagePreviewModalProps {
  imageUrl: string;
  alt: string;
  onClose: () => void;
}

const ItemImagePreviewModal = ({ imageUrl, alt, onClose }: ItemImagePreviewModalProps) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 bg-gray-800/75 z-50 flex items-center justify-center p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={`${alt} image preview`}
    >
      <div className="relative max-w-[90vw] max-h-[90vh]" onClick={(event) => event.stopPropagation()}>
        <button
          type="button"
          onClick={onClose}
          className="absolute -top-10 right-0 text-white hover:text-gray-200"
          aria-label="Close image preview"
        >
          <X className="h-6 w-6" />
        </button>
        <img
          src={imageUrl}
          alt={alt}
          className="max-w-[90vw] max-h-[85vh] w-auto h-auto object-contain rounded-lg shadow-xl bg-white"
        />
        <p className="mt-3 text-center text-sm text-white">{alt}</p>
      </div>
    </div>
  );
};

export default ItemImagePreviewModal;
